import {
    GRID,
    IMAGE_CONATINER,
    IMAGE_STYLES,
    DETAIL_CONTAINER,
    TITLE,
    LIST_STYLE,
    MARGIN_STYLE,
    CONTAINER,
    SUBTITLE,
    CONTAINER_TITLE,
    CONTAINER_SUBTITLE,
} from "./constants";
import ImageAtom from "../../Atoms/ImageAtom";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";
import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import { WARDROBE_STYLING_ENDPOINT } from "../../../public/Constants/EnumConstants";

const StyleMyWardrobeSlice = ({ data }) => {
    return (
        <div className={CONTAINER}>
            <TypographyMontserrat
                align={"center"}
                text={data?.primary?.title}
                customStyle={CONTAINER_TITLE}
            />
            <TypographyMontserrat
                align={"center"}
                text={data?.primary?.subtitle}
                customStyle={CONTAINER_SUBTITLE}
            />
            <div className={GRID}>
                <div className={IMAGE_CONATINER}>
                    <ImageAtom
                        style={IMAGE_STYLES}
                        image={data?.primary?.banner}
                    />
                </div>

                <div className={DETAIL_CONTAINER}>
                    {data?.primary?.data?.map((item, index) => {
                        return (
                            <div key={index}>
                                <div className="flex items-start md:items-center flex-col md:flex-row">
                                    <TypographyMontserrat
                                        customStyle={TITLE}
                                        text={item?.heading}
                                    />
                                    {item?.subheading && (
                                        <TypographyMontserrat
                                            customStyle={SUBTITLE}
                                            text={item?.subheading}
                                        />
                                    )}
                                </div>

                                <ul className={LIST_STYLE}>
                                    {item?.point1 && (
                                        <li className={MARGIN_STYLE}>
                                            <TypographyMontserrat
                                                customStyle={
                                                    "text-sm font-normal"
                                                }
                                                text={item?.point1}
                                            />
                                        </li>
                                    )}
                                    {item?.point2 && (
                                        <li className={MARGIN_STYLE}>
                                            <TypographyMontserrat
                                                customStyle={
                                                    "text-sm font-normal"
                                                }
                                                text={item?.point2}
                                            />
                                        </li>
                                    )}
                                    {item?.point3 && (
                                        <li className={MARGIN_STYLE}>
                                            <TypographyMontserrat
                                                customStyle={
                                                    "text-sm font-normal"
                                                }
                                                text={item?.point3}
                                            />
                                        </li>
                                    )}
                                </ul>
                            </div>
                        );
                    })}

                    <NewPrimaryButton
                        text={data?.primary?.btntext}
                        className={"ml-0"}
                        href={WARDROBE_STYLING_ENDPOINT}
                    />
                </div>
            </div>
        </div>
    );
};
export default StyleMyWardrobeSlice;
